// extracted by mini-css-extract-plugin
export default {"Text":"PrivacyNotice_Text__AW56M"};